module.exports = __webpack_public_path__ + "static/fleet-70-seat-coach-sm-e244079070650f6ef5cd6c900ef154ef.webp";